import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Radar, Trophy, Users, Wallet, TrendingUp, Loader2 } from "lucide-react";

function Card({ icon: Icon, label, value, color }) {
  return (
    <div className="border border-[#222] bg-[#0F0F0F] p-4" data-testid={`mentor-stat-${label}`}>
      <div className="flex items-center gap-2 text-[#888] mb-2"><Icon className="h-4 w-4" style={{ color }} />
        <span className="font-mono-term text-[10px] uppercase tracking-widest">{label}</span></div>
      <div className="font-heading text-2xl font-bold" style={{ color }}>{value}</div>
    </div>
  );
}

export function MentorStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/mentor/stats").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return <div className="flex items-center gap-2 text-[#888] text-sm"><Loader2 className="h-4 w-4 animate-spin" /> Chajman...</div>;
  return (
    <div className="space-y-4 max-w-3xl" data-testid="mentor-stats">
      <h3 className="font-heading font-semibold flex items-center gap-2"><Trophy className="h-4 w-4 text-[#00F593]" /> Estatistik Mwen</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Card icon={Radar} label="Signals" value={s.signals_posted} color="#1C8CFF" />
        <Card icon={TrendingUp} label="Win Rate" value={`${s.win_rate}%`} color="#00F593" />
        <Card icon={Users} label="Referred" value={s.referred_count} color="#f5a623" />
        <Card icon={Wallet} label="Earned" value={`$${s.earnings.total}`} color="#22e07b" />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="border border-[#222] bg-[#0F0F0F] p-4 text-center"><div className="font-heading text-lg font-bold text-[#22e07b]">{s.wins}</div><div className="font-mono-term text-[10px] uppercase text-[#888]">Wins</div></div>
        <div className="border border-[#222] bg-[#0F0F0F] p-4 text-center"><div className="font-heading text-lg font-bold text-[#ff5b5b]">{s.losses}</div><div className="font-mono-term text-[10px] uppercase text-[#888]">Losses</div></div>
        <div className="border border-[#222] bg-[#0F0F0F] p-4 text-center"><div className="font-heading text-lg font-bold text-[#1C8CFF]">{s.active}</div><div className="font-mono-term text-[10px] uppercase text-[#888]">Active</div></div>
      </div>
      <div className="border border-[#222] bg-[#0F0F0F] p-4 flex items-center justify-between">
        <span className="font-mono-term text-xs uppercase text-[#888]">Komisyon</span>
        <span className="font-mono-term text-sm"><span className="text-[#f5a623]">Pending ${s.earnings.pending}</span> · <span className="text-[#00F593]">Paid ${s.earnings.paid}</span></span>
      </div>
    </div>
  );
}
